/* Lamberty Munich · Lieferland-Logik (gemeinsam) + Slide-in als Bestaetigung
   Owner 08.10.2026 Runde 6 (nach Hermes-Muster):
   - Slide-in = nur "Artikel wurde in den Warenkorb gelegt", der Artikel, "Warenkorb ansehen",
     "Weiter einkaufen". Keine Lieferweiche, kein Checkout im Slide-in.
   - Lieferweiche, Versandkosten und Geschenk sitzen auf der Warenkorbseite (assets/lm-cart.js).
   - Land: IP < Website (Laenderwahl im Kopf) < Warenkorb (Auswahl auf der Warenkorbseite).
   - DIRECT = localization.available_countries zur Renderzeit (data-lm-direct), keine feste
     Direktlaenderliste (R-23). W&B-Laender = Seite Lieferung & Rueckgabe.
   - Geschlossene Laender gehen nie an /localization (R-24).
   Stellt window.LMDest fuer die Warenkorbseite bereit.
*/
(function () {
  if (window.LMDest) return;

  var KEY = 'lmCartDest';
  var WEB_KEY = 'lmWebDest';
  var GEO_KEY = 'lmGeoCountry';
  var WB = 'GB AL AD BH BD BA CN GI GG IM JE QA KW MO MY MX ME MK OM KR MD SM SA RS ZA TW TH TR VA VN'.split(' ');
  var EU = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE MC'.split(' ');
  var ALL = 'AD AE AF AG AI AL AM AO AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW XK'.split(' ');

  var NAME = {
    de: { HK: 'Hongkong', MO: 'Macau', CD: 'Demokratische Republik Kongo', CG: 'Republik Kongo', PS: 'Palästinensische Gebiete' },
    en: { HK: 'Hong Kong', MO: 'Macao', CD: 'Democratic Republic of the Congo', CG: 'Republic of the Congo', MM: 'Myanmar', PS: 'Palestinian Territories', US: 'USA' }
  };
  var TO_DE = {
    CH: 'in die Schweiz', TR: 'in die Türkei', SK: 'in die Slowakei', UA: 'in die Ukraine', MN: 'in die Mongolei',
    DO: 'in die Dominikanische Republik', CF: 'in die Zentralafrikanische Republik', CD: 'in die Demokratische Republik Kongo',
    CG: 'in die Republik Kongo', MD: 'in die Republik Moldau', EH: 'in die Westsahara', PS: 'in die Palästinensischen Gebiete',
    US: 'in die USA', NL: 'in die Niederlande', AE: 'in die Vereinigten Arabischen Emirate', GB: 'ins Vereinigte Königreich',
    IR: 'in den Iran', IQ: 'in den Irak', LB: 'in den Libanon', SD: 'in den Sudan', SS: 'in den Südsudan', YE: 'in den Jemen',
    TD: 'in den Tschad', NE: 'in den Niger', VA: 'in die Vatikanstadt',
    PH: 'auf die Philippinen', BS: 'auf die Bahamas', MV: 'auf die Malediven', SC: 'auf die Seychellen', KM: 'auf die Komoren',
    SB: 'auf die Salomonen', MH: 'auf die Marshallinseln', FO: 'auf die Färöer', KY: 'auf die Kaimaninseln',
    VG: 'auf die Britischen Jungferninseln', VI: 'auf die Amerikanischen Jungferninseln', TC: 'auf die Turks- und Caicosinseln',
    FK: 'auf die Falklandinseln', CK: 'auf die Cookinseln', PN: 'auf die Pitcairninseln', AX: 'auf die Ålandinseln',
    MP: 'auf die Nördlichen Marianen', CC: 'auf die Kokosinseln', CX: 'auf die Weihnachtsinsel', NF: 'auf die Norfolkinsel',
    IM: 'auf die Isle of Man'
  };
  var THE_EN = 'US GB NL AE PH BS MV KM SB MH FO KY VG VI TC FK CK PN AX MP CC DO CF CD CG GM PS SC'.split(' ');

  function lsGet(k) { try { return window.localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function cfg() { return document.querySelector('[data-lm-direct]'); }
  function directList() { var c = cfg(); return c ? (c.getAttribute('data-lm-direct') || '').split(',').filter(Boolean) : []; }

  function countryName(code, l) {
    var n = NAME[l] && NAME[l][code];
    if (n) return n;
    try { return new Intl.DisplayNames([l], { type: 'region' }).of(code) || code; } catch (e) { return code; }
  }
  function toPhrase(code, l) {
    if (l === 'de') return TO_DE[code] || 'nach ' + countryName(code, l);
    return 'to ' + (THE_EN.indexOf(code) > -1 ? 'the ' : '') + countryName(code, l);
  }
  function stateOf(code) {
    if (!code) return 'GEO';
    if (directList().indexOf(code) > -1) return 'A';
    if (WB.indexOf(code) > -1) return 'B';
    return 'C';
  }

  var geoPromise = null;
  function detect() {
    var cached = ssGet(GEO_KEY);
    if (cached) return Promise.resolve(cached === '-' ? '' : cached);
    if (!geoPromise) {
      geoPromise = fetch(root() + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          c = c && ALL.indexOf(c) > -1 ? c : '';
          ssSet(GEO_KEY, c || '-');
          return c;
        })
        .catch(function () { return ''; });
    }
    return geoPromise;
  }
  /* Rangfolge: Warenkorb vor Website vor IP */
  function resolveCountry() {
    var chosen = lsGet(KEY) || lsGet(WEB_KEY);
    return chosen ? Promise.resolve(chosen) : detect();
  }
  function setCartChoice(code) { if (code) lsSet(KEY, code); }

  /* Direktland -> Shopify-Land nachziehen (Warenkorb, Preise, Checkout). Nie fuer geschlossene Laender. */
  function updateLocalization(code) {
    var el = cfg();
    var ctx = el ? el.getAttribute('data-lm-ctx') : '';
    if (!el || !code || code === ctx || stateOf(code) !== 'A') return Promise.resolve(false);
    var form = document.querySelector('form.lm-cd__loc');
    if (!form) return Promise.resolve(false);
    var fd = new FormData(form);
    fd.set('country_code', code);
    fd.set('return_to', window.location.pathname);
    return fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        /* Review 10.10.2026: nur bei erfolgreicher Antwort als gewechselt werten */
        if (!r || !r.ok) return false;
        document.querySelectorAll('[data-lm-ctx]').forEach(function (x) { x.setAttribute('data-lm-ctx', code); });
        return true;
      })
      .catch(function () { return false; });
  }

  window.LMDest = {
    ALL: ALL, WB: WB, EU: EU,
    countryName: countryName, toPhrase: toPhrase, stateOf: stateOf, detect: detect,
    resolveCountry: resolveCountry, setCartChoice: setCartChoice, updateLocalization: updateLocalization,
    root: root
  };

  detect();

  /* Laenderwahl im Kopf (Shopify-Formular) = Wahl auf der Website */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/localization"]') || f.classList.contains('lm-cd__loc')) return;
    var cc = f.querySelector('[name="country_code"]');
    if (cc && cc.value) lsSet(WEB_KEY, cc.value);
  }, true);

  /* ---------- Slide-in: nur Bestaetigung des eben hinzugefuegten Artikels ---------- */
  function setFocus(id) {
    var st = document.getElementById('lm-cd-focus');
    if (!st) { st = document.createElement('style'); st.id = 'lm-cd-focus'; document.head.appendChild(st); }
    var safe = String(id || '').replace(/[^0-9]/g, '');
    st.textContent = safe ? 'cart-drawer .cart-item:not([data-lm-variant="' + safe + '"]){display:none !important}' : '';
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var idInput = f.querySelector('[name="id"]');
    if (idInput) setFocus(idInput.value);
  }, true);

  /* Runde 8 (Owner): Shopify-Hinweis "maximale Menge ... in deinem Warenkorb" auf der
     Produktseite durch den Owner-Wortlaut ersetzen (Sie-Form). Andere Fehler bleiben unveraendert. */
  var MAXED = {
    de: 'Sie haben bereits das letzte verfügbare Tuch in den Warenkorb gelegt.',
    en: 'You have already added the last available scarf to your basket.'
  };
  var MAX_RE = /maximale Menge|maximum quantity|bereits in deinem Warenkorb|already in your cart|can.t add more|kannst .* nicht mehr/i;
  function watchError(f) {
    var host = f.closest('product-form') || f.parentElement;
    if (!host || host.__lmMaxWatch) return;
    host.__lmMaxWatch = true;
    var l = (document.documentElement.lang || '').slice(0, 2) === 'de' ? 'de' : 'en';
    var fix = function () {
      host.querySelectorAll('.product-form__error-message').forEach(function (el) {
        var tx = el.textContent || '';
        if (tx && tx !== MAXED[l] && MAX_RE.test(tx)) el.textContent = MAXED[l];
      });
    };
    new MutationObserver(fix).observe(host, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[action*="/cart/add"]')) watchError(f);
  }, true);

  /* Warenkorb-Symbol im Kopf -> Warenkorbseite statt Slide-in */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#cart-icon-bubble');
    if (!a) return;
    e.stopImmediatePropagation();
  }, true);

  /* "Weiter einkaufen" im Slide-in schliesst es */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lm-close-drawer]');
    if (!b) return;
    e.preventDefault();
    var dr = document.querySelector('cart-drawer');
    if (dr && typeof dr.close === 'function') dr.close();
  });

  /* Checkout-Klick (Warenkorbseite): gewaehltes Direktland sicher an Shopify uebergeben */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn) return;
    var code = lsGet(KEY) || lsGet(WEB_KEY);
    var el = cfg();
    if (!el || !code || stateOf(code) !== 'A' || code === el.getAttribute('data-lm-ctx')) return;
    var form = document.querySelector('form.lm-cd__loc');
    if (!form) return;
    e.preventDefault();
    form.querySelector('[name="country_code"]').value = code;
    var rt = form.querySelector('[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
    rt.value = '/checkout';
    form.submit();
  }, true);
})();
